import { Lock, ShieldOff, BadgeCheck } from "lucide-react";
import Reveal from "@/components/ui/reveal";

const MODELS = [
    {
        name: "Claude Sonnet 4.5",
        role: "AI Doradca & analiza dokumentów",
        desc: "Rozumie polskie przepisy, tłumaczy zagadnienia podatkowe w zrozumiały sposób i pilnuje kontekstu Twojej firmy.",
        tag: "reasoning",
    },
    {
        name: "Gemini 2.5 Flash",
        role: "OCR & szybkie odczyty",
        desc: "Błyskawicznie odczytuje faktury i paragony ze zdjęć — kwoty, VAT, kontrahent.",
        tag: "vision · fast",
    },
];

const TRUST = [
    { icon: Lock, title: "Podpis HMAC", desc: "Każde żądanie podpisane i szyfrowane end-to-end." },
    { icon: ShieldOff, title: "Zero trenowania", desc: "Twoje dane nie trafiają do treningu modeli. Nigdy." },
    { icon: BadgeCheck, title: "Zgodność z RODO", desc: "Przetwarzanie w UE, pełna kontrola i prawo do usunięcia." },
];

export default function AIStack() {
    return (
        <section id="ai" className="py-20 lg:py-28">
            <div className="container-gr">
                <Reveal className="overflow-hidden rounded-3xl border border-gr-dline bg-gr-dbg text-gr-dink">
                    <div className="grain absolute opacity-[0.05]" aria-hidden />
                    <div className="relative p-8 sm:p-12">
                        <p className="font-mono text-xs uppercase tracking-[0.2em] text-gr-accent">// AI Stack</p>
                        <h2 className="mt-3 max-w-2xl text-3xl tracking-tight text-white sm:text-4xl">
                            Dwa modele AI, jeden cel — Twoja zgodność i spokój.
                        </h2>
                        <p className="mt-4 max-w-2xl text-gr-dsub">
                            Łączymy najlepsze AI do konkretnych zadań — rozumowanie i szybkie odczyty — zamiast jednego modelu do wszystkiego.
                        </p>

                        <div className="mt-10 grid gap-4 md:grid-cols-2">
                            {MODELS.map((m) => (
                                <div key={m.name} className="rounded-2xl border border-gr-dline bg-gr-dsurface p-6">
                                    <div className="flex items-center justify-between">
                                        <h3 className="font-mono text-lg font-bold text-white">{m.name}</h3>
                                        <span className="rounded-full bg-gr-accent/15 px-3 py-1 font-mono text-[10px] uppercase tracking-wider text-gr-accent">{m.tag}</span>
                                    </div>
                                    <p className="mt-2 text-sm font-semibold text-gr-dprimary">{m.role}</p>
                                    <p className="mt-2 text-sm text-gr-dsub">{m.desc}</p>
                                </div>
                            ))}
                        </div>

                        <div className="mt-6 grid gap-4 rounded-2xl border border-gr-dline bg-gr-dsurface2 p-6 sm:grid-cols-3">
                            {TRUST.map((t) => (
                                <div key={t.title} data-testid={`ai-trust-${t.title}`} className="flex items-start gap-3">
                                    <t.icon className="mt-0.5 h-5 w-5 shrink-0 text-gr-accent" />
                                    <div>
                                        <p className="text-sm font-semibold text-white">{t.title}</p>
                                        <p className="mt-1 text-xs text-gr-dsub">{t.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
